/* eslint-disable */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

const CommunityFilterPopup = ({
  token,
  tagList,
  memberList,
  setfilterTags,
  setFilterDateRange,
  setfilterWinnerPost,
  setfilterNotWinnerPost,
  setfilterPostMods,
}) => {
  const [tagValues, settagValues] = useState([]);
  const [postedByValue, setPostedByValue] = useState(null);
  const [postedByList, setPostedByList] = useState([]);
  const [fromDate, setfromDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [isWinnerForum, setIsWinnerForum] = useState(false);
  const [isNotWinnerForum, setIsNotWinnerForum] = useState(false);

  //function for select event tags
  const tagSelectionHandler = (data) => {
    let prevTagValues = tagValues;

    if (prevTagValues.includes(data.value)) {
      let selectedItem = document.getElementById("filtertagli-" + data.value);

      selectedItem.classList.remove("active");

      // exist in array, thus remove
      let key = prevTagValues.indexOf(data.value);
      prevTagValues.splice(key, 1);
    } else {
      let selectedItem = document.getElementById("filtertagli-" + data.value);

      selectedItem.classList.add("active");
      // not exist in array, thus add
      prevTagValues.push(data.value);
    }

    settagValues(prevTagValues);
  };

  //function for remove active class for selected tags
  const removeActiveClass = () => {
    const liElements = document.querySelectorAll(".filtertagstyle");

    liElements.forEach((li) => {
      li.classList.remove("active");
    });
  };

  //posted by select
  const postedBySelectionHandler = (val) => {
    setPostedByValue(val);
    setPostedByList(val.map((item) => item.value));
  };

  //function for assign search data for filter and close pop up
  const searchHandler = () => {
    //check start date and end date are not empty.If end date empty then only search by start date
    if (fromDate != "" && toDate != "" && fromDate < toDate) {
      setFilterDateRange(fromDate + "," + toDate);
    } else if (fromDate != "") {
      setFilterDateRange(fromDate);
    }

    setfilterPostMods(postedByList);
    setfilterTags(tagValues);
    setfilterWinnerPost(isWinnerForum);
    setfilterNotWinnerPost(isNotWinnerForum);

    // close the offcanvas of filter
    let offCanvasPopup = document.querySelector("#offcanvasRight");
    let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
    offCanvas.hide();
    resetHandler();
  };

  //function for reset search
  const resetHandler = () => {
    removeActiveClass();
    setfromDate("");
    settoDate("");
    setIsWinnerForum(false);
    setIsNotWinnerForum(false);
    settagValues([]);
    setPostedByValue(null);
    setPostedByList([]);
  };

  return (
    <div className="offcanvas_sidebar">
      <div
        className="offcanvas offcanvas-end body_bg"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasTopLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="close-btn text-reset filter_cross d-flex align-items-center justify-content-center"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={resetHandler}
          >
            <span className="material-icons-outlined">close</span>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="filter_outerbx">
            {/* date range */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Created </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="d-flex gap-2">
                <input
                  type="date"
                  className="form-control"
                  placeholder="From"
                  value={fromDate}
                  onChange={(e) => setfromDate(e.target.value)}
                />

                <input
                  type="date"
                  className="form-control "
                  placeholder="To"
                  value={toDate}
                  onChange={(e) => settoDate(e.target.value)}
                />
              </div>
            </div>

            {/* posted by */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Posted by</h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="price_range d-flex gap-2">
                <div className="price_fill w-100">
                  <Select
                    placeholder="Select Posted By"
                    isMulti
                    options={memberList}
                    value={postedByValue}
                    onChange={(val) => postedBySelectionHandler(val)}
                  />
                </div>
              </div>
            </div>

            {/* tags */}
            {token && (
              <div className="product_filtr_item mb-3">
                <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                  <div className="filter_name">
                    <h4 className="fs-sm fw-medium text-primary">Tags</h4>
                  </div>
                  <span className="accor_arw">
                    <i className="material-icons-outlined">
                      {" "}
                      keyboard_arrow_down
                    </i>
                  </span>
                </div>
                <div className="filter_info">
                  <div className="filter_list department_info">
                    <ul className="list_style_none d-flex gap-2 flex-wrap">
                      {/* <li className="active">All Sector</li> */}
                      {tagList.map((tag, index) => {
                        return (
                          <li
                            key={index}
                            id={"filtertagli-" + tag.value}
                            onClick={() => {
                              tagSelectionHandler(tag);
                            }}
                            className="filtertagstyle"
                          >
                            {tag.label}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* ecosystem */}
            {/* <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Ecosystem</h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <ul className="list_style_none d-flex gap-2 flex-wrap">
                    <li>All Ecosystem</li>
                    <li>Indra</li>
                    <li className="active">Findelit</li>
                    <li>Lobees</li>
                    <li>SportsMoon</li>
                    <li>Crowcol</li>
                    <li>Enaire</li>
                    <li>Saludti</li>
                    <li>FindelDron</li>
                  </ul>
                </div>
              </div>
            </div> */}

            {/* winner */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Winner</h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <ul className="list_style_none d-flex gap-2 flex-wrap">
                    {/* <li className="active">All</li> */}
                    <li
                      className={isWinnerForum ? "active" : ""}
                      onClick={() => {
                        setIsWinnerForum(!isWinnerForum);
                        setIsNotWinnerForum(false);
                      }}
                    >
                      Winner Selected
                    </li>
                    <li
                      className={isNotWinnerForum ? "active" : ""}
                      onClick={() => {
                        setIsNotWinnerForum(!isNotWinnerForum);
                        setIsWinnerForum(false);
                      }}
                    >
                      Not Selected
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* <div className="product_filtr_item">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Members </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="price_range d-flex gap-2">
                <div className="price_fill">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Min"
                  />
                </div>
                <div className="price_fill">
                  <input
                    type="number"
                    className="form-control "
                    placeholder="Max"
                  />
                </div>
                <div className="go_btn">
                  <input
                    type="submit"
                    value="Go"
                    className="go_price btn primary-btn"
                  />
                </div>
              </div>
            </div> */}
            <button
              type="button"
              className="btn primary-btn fs-sm fw-normal w-100 mt-4"
              onClick={searchHandler}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityFilterPopup;
